
<label class="monospace">
  <a *ngIf="showRemove" (click)="clickRemove()">
    <i class="fa fa-left fa-times text-danger"></i>
  </a>
  <span>{{label}}</span>
  <span class="text-primary" *ngIf="required">*</span>
  <span>:</span>
  <span class="hl-key" *ngIf="!typeChoices">{{type}}</span>
  <div class="type-choice dropdown" *ngIf="typeChoices">
    <a class="btn btn-xs btn-default dropdown-toggle" data-toggle="dropdown">
      <span>{{type}}</span>
      <i class="fa fa-right fa-caret-down"></i>
    </a>
    <ul class="dropdown-menu">
      <li *ngFor="let t of typeChoices">
        <a (click)="type = t; typeChange.emit(type)">{{t}}</a>
      </li>
    </ul>
  </div>
  <div class="type-choice dropdown" *ngIf="subtypeChoices">
    <a class="btn btn-xs btn-default dropdown-toggle" data-toggle="dropdown">
      <span>{{subtype?.title || 'Choose one'}}</span>
      <i class="fa fa-right fa-caret-down"></i>
    </a>
    <ul class="dropdown-menu">
      <li *ngFor="let t of subtypeChoices">
        <a (click)="subtype = t; expand ? null : toggleExpand(); subtypeChange.emit(t)">{{t.title}}</a>
      </li>
    </ul>
  </div>
  <tooltip-content #descriptionTooltip *ngIf="description">
    <div [innerHtml]="marked(description)"></div>
  </tooltip-content>
  <a *ngIf="description" [tooltip]="descriptionTooltip" tooltipPlacement="right">
    <i class="fa fa-right fa-question-circle"></i>
  </a>
  <a *ngIf="(showExpand && (type === 'object' || type === 'array')) || schema.$ref"
    (click)="toggleExpand()">
    <i class="fa fa-right" [class.fa-plus-square-o]="!expand" [class.fa-minus-square-o]="expand"></i>
  </a>
</label>
<p class="text-danger" *ngIf="!schema">Unknown schema</p>
    


// WEBPACK FOOTER //
// ./src/app/json-schema-form/schema-label.component.ts.SchemaLabelComponent.html